// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__2TBcl","list":"TableCells_list__1g8Qx","firstItemBold":"TableCells_firstItemBold__1TWpF","link":"TableCells_link__1AJhi"};